export default "__VITE_ASSET__CB1A_H0p__"